import { RefreshCw } from "lucide-react";
import { Link, useLocation } from "@tanstack/react-router";
import { Button } from "@/components/button";

export function Header({
  title,
  author,
  onUploadUpdatedManuscript,
}: {
  title: string;
  author: string;
  onUploadUpdatedManuscript: () => void;
}) {
  const location = useLocation();
  const isOverview =
    location.pathname === "/innovation-days-demo" ||
    location.pathname === "/innovation-days-demo/";
  const isViewer = location.pathname === "/innovation-days-demo/viewer";
  const isSummary = location.pathname === "/innovation-days-demo/summary";

  return (
    <div className="flex flex-col gap-3 md:gap-4 z-100 bg-secondary-50 pb-2 py-12">
      <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
        <div className="flex flex-col gap-3 px-4 w-full md:w-[395px]">
          <div className="flex flex-col h-[30px] w-full">
            <h1
              className="text-[30px] font-semibold leading-[100%] overflow-hidden self-stretch"
              style={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
                color: "#0F172A",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </h1>
          </div>
          <div className="flex items-center gap-1 h-[18px] w-full relative">
            <p
              className="text-[16px] font-medium leading-[100%] overflow-ellipsis overflow-hidden whitespace-nowrap"
              style={{ color: "#94A3B8" }}
            >
              {author}
            </p>
          </div>
        </div>
        <Button
          variant="default"
          className="flex items-center gap-2 h-9 w-full md:w-auto"
          onClick={onUploadUpdatedManuscript}
        >
          <RefreshCw className="w-4 h-4" />
          Update Manuscript
        </Button>
      </div>

      <div
        className="p-1 h-9 rounded-2xl flex items-center w-full md:w-[801px]"
        style={{
          background:
            "linear-gradient(0deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.40) 100%), #F1F5F9",
        }}
      >
        <Link
          to="/innovation-days-demo"
          data-testid="tab-overview"
          className={`flex py-1 px-3 justify-center items-center gap-2 flex-1 border-0 rounded-xl text-center text-sm font-medium leading-5 ${
            isOverview
              ? "bg-white text-foreground shadow-[0px_0px_2px_0px_rgba(0,0,0,0.08),0px_3px_10px_0px_rgba(0,0,0,0.06)]"
              : "text-secondary-600"
          }`}
        >
          Overview
        </Link>
        <Link
          to="/innovation-days-demo/summary"
          data-testid="tab-summary"
          className={`flex py-1 px-3 justify-center items-center gap-2 flex-1 border-0 rounded-xl text-center text-sm font-medium leading-5 ${
            isSummary
              ? "bg-white text-foreground shadow-[0px_0px_2px_0px_rgba(0,0,0,0.08),0px_3px_10px_0px_rgba(0,0,0,0.06)]"
              : "text-secondary-600"
          }`}
        >
          Summary
        </Link>
        <Link
          to="/innovation-days-demo/viewer"
          search={{ annotationType: null }}
          data-testid="tab-manuscript"
          className={`flex py-1 px-3 justify-center items-center gap-2 flex-1 border-0 rounded-xl text-center text-sm font-medium leading-5 ${
            isViewer
              ? "bg-white text-foreground shadow-[0px_0px_2px_0px_rgba(0,0,0,0.08),0px_3px_10px_0px_rgba(0,0,0,0.06)]"
              : "text-secondary-600"
          }`}
        >
          Manuscript
        </Link>
      </div>
    </div>
  );
}
